import {axiosInstance} from "~/js/api/axios";
import {useMutation, useQuery} from "@tanstack/react-query";

export const fetchInviteFriendForm = async ({ inviteFriendUrl }) => {
  const response = await axiosInstance.get(inviteFriendUrl);
  return response.data;
};

export const useInviteFriendForm = ({ inviteFriendUrl }) => {
  return useQuery({
    queryKey: ["invite-friend-form", inviteFriendUrl],
    queryFn: () => fetchInviteFriendForm({ inviteFriendUrl }),
  });
};

export const sendInviteEmail = async ({ url, body }) => {
  const response = await axiosInstance.post(url, body);
  return response.data;
};

export const useInviteEmail = () => {
  return useMutation({
    mutationFn: async ({ url, body }) => {
      return await sendInviteEmail({ url, body });
    },
    onSuccess: (data, { successHandler }) => {
      if (successHandler) {
        successHandler(data);
      }
    },
    onError: (data, { errorHandler }) => {
      if (errorHandler) {
        errorHandler(data);
      }
    },
  });
};
